/**
 * HVN: Saved Properties block registration.
 *
 * Presentation layer only. The saved/favorited list, storage, REST and card
 * rendering all come from the existing Favorites + Property Card systems — this
 * block adds no new favorites logic.
 *
 * @package
 * @since   3.5.0
 */

import { registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import Edit from './edit';
import icon from '../shared/icon';

registerBlockType( metadata.name, {
	icon,
	edit: Edit,
	save: () => null,
} );
